import { useNavigate, useLocation } from 'react-router-dom';
import { useUiStore } from '@/stores';
import {
  Calendar, Megaphone, Users, LayoutDashboard, Settings, ChevronLeft, ChevronRight,
} from 'lucide-react';
import { clsx } from 'clsx';

const NAV_ITEMS = [
  { path: '/', icon: Calendar, label: 'Citas', view: 'appointments' as const },
  { path: '/campaigns', icon: Megaphone, label: 'Campañas', view: 'campaigns' as const },
  { path: '/crm', icon: Users, label: 'CRM', view: 'crm' as const },
  { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard', view: 'dashboard' as const },
  { path: '/settings', icon: Settings, label: 'Ajustes', view: 'settings' as const },
];

export function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);
  const setCurrentView = useUiStore((s) => s.setCurrentView);

  return (
    <aside className={clsx(
      'h-dvh bg-surface border-r border-border flex flex-col transition-all duration-300',
      collapsed ? 'w-16' : 'w-56'
    )}>
      {/* Brand */}
      <div className="p-4 border-b border-border">
        <h2 className={clsx(
          'font-bold text-brand-primary transition-all',
          collapsed ? 'text-center text-sm' : 'text-xl'
        )}>
          {collapsed ? 'FH' : 'Fresha Hub'}
        </h2>
      </div>

      {/* Nav links */}
      <nav className="flex-1 py-2">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <button
              key={item.path}
              onClick={() => { navigate(item.path); setCurrentView(item.view); }}
              className={clsx(
                'w-full flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-brand-primary/10 text-brand-primary border-r-2 border-brand-primary'
                  : 'text-text-secondary hover:bg-surface-secondary hover:text-text-primary'
              )}
            >
              <item.icon size={20} />
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </nav>

      {/* Collapse toggle */}
      <button
        onClick={toggleSidebar}
        className="p-4 border-t border-border text-text-muted hover:text-text-primary transition-colors"
      >
        {collapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
      </button>
    </aside>
  );
}
